import { render, staticRenderFns } from "./RulesHub.vue?vue&type=template&id=8ff7f5e6&scoped=true"
import script from "./RulesHub.vue?vue&type=script&lang=js"
export * from "./RulesHub.vue?vue&type=script&lang=js"
import style0 from "./RulesHub.vue?vue&type=style&index=0&id=8ff7f5e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff7f5e6",
  null
  
)

export default component.exports